import React from "react";
import { Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import "../../styles/compareWizard.css";

// Consistent footer for each compare wizard step: Back (secondary) on the left,
// the primary action (Next / Run) on the right, above a hairline divider.
// Purely presentational — it just fires the callbacks the panes already use.
function StepFooter({
  showBack = true,
  onBack,
  onNext,
  nextLabel = "Next",
  nextDisabled = false,
}) {
  return (
    <div className="cmp-footer">
      {showBack ? (
        <Button icon={<ArrowLeftOutlined />} onClick={onBack}>
          Back
        </Button>
      ) : (
        <span />
      )}
      <Button type="primary" onClick={onNext} disabled={nextDisabled}>
        {nextLabel}
      </Button>
    </div>
  );
}

export default StepFooter;
